import { type SpiffToolAdminAction, SQSEmail, type Task, User } from '@kalos/kalos-rpc';
import { format, parseISO } from 'date-fns';

import { getKalosLogoUrl } from '../../../../hooks/react-query/useKalosLogoQuery';
import { EmailClientService, UserClientService } from '../../../../tools/helpers';

const statusLabel = (status: number) =>
  status === 2 ? 'Declined' : status === 3 ? 'Revoked' : 'Approved';

export const sendSpiffDecisionEmail = async (
  task: Task,
  recipient: Pick<User, 'id' | 'firstname' | 'lastname' | 'email'>,
  action: SpiffToolAdminAction,
) => {
  const logoUrl = await getKalosLogoUrl('onDark');
  const emailStatus = statusLabel(action.status);
  const body = `<body>

      <table cellpadding="0" cellspacing="0" class="main-table" style="max-width:600px; margin:auto; border:1px solid #ddd; background-color:#f1f1f1;" align="center">
       <tr>
      <td height="12"></td>
    </tr>
    <tr>
      <td>
      </td>
    </tr>

      <tr>
        <td height="10" colspan="3"></td>
      </tr>
      <tr>
        <td width="2%"></td>
        <td width="96%">
          <table style="width:100%; margin:auto; background-color:#fff;" cellpadding="0" cellspacing="0">
            <tr>
              <td width="2%"></td>
              <td width="96%">
                <table style="width:100%;" cellpadding="0" cellspacing="0">
                  <tr>
                    <td height="12"></td>
                  </tr>
                  <a><img src='${logoUrl}' width="175"	alt="email-logo" style="display:block; background-color: #711313"/></a>

                  <tr>
                    <td height="23"></td>
                  </tr>
                  <tr>
                    <td height="22"></td>
                  </tr>
                  <tr>
                    <td>
                      <h3 style="font-size:20px; color:#4d4d4d; font-family:Arial, Helvetica, sans-serif; margin:0;">
                        Hello ${recipient.firstname} ${recipient.lastname}
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td height="14"></td>
                  </tr>
                  <tr>
                    <td>
                      <p style="margin:0; font-size:14px; color:#262626; line-height:20px; font-family:Arial, Helvetica, 'sans-serif';">
                        Your request for your Spiff has been <b>${emailStatus}</b>.<br/>Please see details below
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td height="10"></td>
                  </tr>
                  <tr>
                    <td colspan="3" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:14px; line-height:20px; font-weight:bold;">${
                      recipient.firstname
                    } ${recipient.lastname} : Spiff Request</td>
                   </tr>
                   <tr>
                   <td colspan="3" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:14px; line-height:20px; font-weight:bold;">Amount:$ ${
                     task.spiffAmount
                   }</td>

                  </tr>
                  <tr>
                    <td height="10"></td>
                  </tr>
                  <tr>
                    <td>
                      <table style="width:100%;" cellpadding="1" cellspacing="1">
                        <tr>
                          <th valign="top" width="21%" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:13px; line-height:20px;" align="left" width="28%">Decision Date</th>
                          <th valign="top" width="22%" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:13px; line-height:20px;" align="left" width="24%">Reviewed By</th>
                          <th valign="top" width="22%" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:13px; line-height:20px;" align="left" width="24%">Job Number</th>
                          <th valign="top" width="13%" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:13px; line-height:20px;" align="left">Status</th>
                         </tr>
                        <tr>
                          <td valign="top" style="font-fdamily:Arial, Helvetica, sans-serif; color:#000; font-size:12px; line-height:20px;"> ${format(
                            parseISO(action.decisionDate),
                            'yyyy-MM-dd',
                          )} </td>
                          <td valign="top" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:12px; line-height:20px;">${
                            action.reviewedBy
                          }</td>

                          <td valign="top" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:12px; line-height:20px;">${task.spiffJobNumber}</td>
                          <td valign="top" style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:12px; line-height:20px;">${emailStatus}</td>
                         </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td height="18"></td>
                  </tr>
                  <tr>

                  <tr style="font-family:Arial, Helvetica, sans-serif; color:#000; font-size:12px; line-height:20px;">
                  <td>
                  <h3>Reason</h3>
                  <p>${action.reason ?? 'N/A'}</p>
                  </td>
                  </tr>

                  </tr>
                    <tr>
                    <td height="18"></td>
                  </tr>
                </table>
              </td>
              <td width="2%"></td>
            </tr>
          </table>
        </td>
        <td width="2%"></td>
      </tr>
      <tr>
        <td height="13" colspan="3"></td>
      </tr>
      <tr>
        <td width="2%"></td>
        <td width="96%">
             <table style="width:100%; border-top:1px solid #d8d8d8;" cellpadding="0" cellspacing="0">
            <tr>
              <td height="10" colspan="2"></td>
            </tr>
            <tr>
              <td width="80%" align="right" valign="middle">
                <span style="font-size:10px; color:#595959; font-family:Arial, Helvetica, sans-serif; font-weight:300; line-height:13px;">
                  KALOS SERVICES INC. 236 HATTERAS AVE CLERMONT FL 34711 &nbsp; 352.243.7088 <br />
                  Copyright 2022 Kalos Service Inc. All Rights Reserved.
                </span>
              </td>
              <td width="20%" align="right">
              </td>
            </tr>
          </table>
        </td>
        <td width="2%"></td>
      </tr>
      <tr>
        <td height="30" colspan="3"></td>
      </tr>
    </table>
    </body>`;

  const email = SQSEmail.create();
  email.body = body;
  email.subject = `Spiff ${task.spiffJobNumber} Update`;
  email.to = recipient.email;
  if (email.to == '') {
    const taskUserInfo = await UserClientService.Get(User.create({ id: task.externalId }));
    email.to = taskUserInfo.email;
  }
  try {
    await EmailClientService.SendSQSMail(email);
  } catch (e) {
    console.log('could not send email ', e);
  }
};
